"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADDITIONAL_CONTACTS = exports.ADDON_TRANSACTIONAL_EMAIL = exports.ADDON_ADDITIONAL_PORTAL = exports.ADDON_DEDICATED_IP = exports.ADDON_WEBSITE_UNLIMITED = exports.ADDON_WEBSITE_STARTER = exports.ADDON_ADS = exports.ADDON_REPORTING = exports.PRODUCT_SERVICE_ENTERPRISE_ADDITIONAL_USER = exports.PRODUCT_SERVICE_ENTERPRISE = exports.PRODUCT_SERVICE_PROFESSIONAL_ADDITIONAL_USER = exports.PRODUCT_SERVICE_PROFESSIONAL = exports.PRODUCT_SERVICE_STARTER = exports.PRODUCT_SERVICE_FREE = exports.PRODUCT_MARKETING_STARTER_EMAIL = exports.PRODUCT_MARKETING_ENTERPRISE = exports.PRODUCT_MARKETING_PRO = exports.PRODUCT_MARKETING_BASIC = exports.PRODUCT_MARKETING_STARTER = exports.PRODUCT_MARKETING_FREE = exports.PRODUCT_SALES_ENTERPRISE_ADDITIONAL_USER = exports.PRODUCT_SALES_ENTERPRISE = exports.PRODUCT_SALES_PROFESSIONAL_ADDITIONAL_USER = exports.PRODUCT_SALES_PROFESSIONAL = exports.PRODUCT_SALES_STARTER = exports.PRODUCT_SALES_FREE = exports.PRODUCT_SALES_POWER_USER = exports.PRODUCT_SALES_PRO_LEGACY = exports.PRODUCT_CRM = void 0;
var PRODUCT_CRM = ['sales'];
exports.PRODUCT_CRM = PRODUCT_CRM;
var PRODUCT_SALES_PRO_LEGACY = ['sales-pro'];
exports.PRODUCT_SALES_PRO_LEGACY = PRODUCT_SALES_PRO_LEGACY;
var PRODUCT_SALES_POWER_USER = ['sales-power'];
exports.PRODUCT_SALES_POWER_USER = PRODUCT_SALES_POWER_USER;
var PRODUCT_SALES_FREE = ['sales'];
exports.PRODUCT_SALES_FREE = PRODUCT_SALES_FREE;
var PRODUCT_SALES_STARTER = ['sales-starter']; // Sales Pro users are grandfathered into Sales Professional.

exports.PRODUCT_SALES_STARTER = PRODUCT_SALES_STARTER;
var PRODUCT_SALES_PROFESSIONAL = ['sales-pro-bundle'].concat(PRODUCT_SALES_PRO_LEGACY);
exports.PRODUCT_SALES_PROFESSIONAL = PRODUCT_SALES_PROFESSIONAL;
var PRODUCT_SALES_PROFESSIONAL_ADDITIONAL_USER = ['sales-pro-additional-seat'];
exports.PRODUCT_SALES_PROFESSIONAL_ADDITIONAL_USER = PRODUCT_SALES_PROFESSIONAL_ADDITIONAL_USER;
var PRODUCT_SALES_ENTERPRISE = ['sales-enterprise-bundle'];
exports.PRODUCT_SALES_ENTERPRISE = PRODUCT_SALES_ENTERPRISE;
var PRODUCT_SALES_ENTERPRISE_ADDITIONAL_USER = ['sales-enterprise-additional-seat'];
exports.PRODUCT_SALES_ENTERPRISE_ADDITIONAL_USER = PRODUCT_SALES_ENTERPRISE_ADDITIONAL_USER;
var PRODUCT_MARKETING_FREE = ['marketing-free-2016'];
exports.PRODUCT_MARKETING_FREE = PRODUCT_MARKETING_FREE;
var PRODUCT_MARKETING_STARTER = ['marketing-starter-2016'];
exports.PRODUCT_MARKETING_STARTER = PRODUCT_MARKETING_STARTER;
var PRODUCT_MARKETING_BASIC = ['marketing-basic-2011', 'marketing-basic-2012', 'marketing-basic-2013'];
exports.PRODUCT_MARKETING_BASIC = PRODUCT_MARKETING_BASIC;
var PRODUCT_MARKETING_PRO = ['marketing-pro-2011', 'marketing-pro-2012', 'marketing-pro-2013'];
exports.PRODUCT_MARKETING_PRO = PRODUCT_MARKETING_PRO;
var PRODUCT_MARKETING_ENTERPRISE = ['marketing-ent-2011', 'marketing-ent-2012', 'marketing-ent-2013'];
exports.PRODUCT_MARKETING_ENTERPRISE = PRODUCT_MARKETING_ENTERPRISE;
var PRODUCT_MARKETING_STARTER_EMAIL = ['marketing-starter-2018'];
exports.PRODUCT_MARKETING_STARTER_EMAIL = PRODUCT_MARKETING_STARTER_EMAIL;
var PRODUCT_SERVICE_FREE = ['sales'];
exports.PRODUCT_SERVICE_FREE = PRODUCT_SERVICE_FREE;
var PRODUCT_SERVICE_STARTER = ['service-starter'];
exports.PRODUCT_SERVICE_STARTER = PRODUCT_SERVICE_STARTER;
var PRODUCT_SERVICE_PROFESSIONAL = ['service-professional-bundle'];
exports.PRODUCT_SERVICE_PROFESSIONAL = PRODUCT_SERVICE_PROFESSIONAL;
var PRODUCT_SERVICE_PROFESSIONAL_ADDITIONAL_USER = ['service-professional-additional-seat'];
exports.PRODUCT_SERVICE_PROFESSIONAL_ADDITIONAL_USER = PRODUCT_SERVICE_PROFESSIONAL_ADDITIONAL_USER;
var PRODUCT_SERVICE_ENTERPRISE = ['service-enterprise-bundle'];
exports.PRODUCT_SERVICE_ENTERPRISE = PRODUCT_SERVICE_ENTERPRISE;
var PRODUCT_SERVICE_ENTERPRISE_ADDITIONAL_USER = ['service-enterprise-additional-seat'];
exports.PRODUCT_SERVICE_ENTERPRISE_ADDITIONAL_USER = PRODUCT_SERVICE_ENTERPRISE_ADDITIONAL_USER;
var ADDON_REPORTING = ['reporting', 'reporting-grandfathered'];
exports.ADDON_REPORTING = ADDON_REPORTING;
var ADDON_ADS = ['ads', 'ads-grandfathered'];
exports.ADDON_ADS = ADDON_ADS;
var ADDON_WEBSITE_STARTER = ['sites', 'sites-basic-2014', 'sites-grandfathered'];
exports.ADDON_WEBSITE_STARTER = ADDON_WEBSITE_STARTER;
var ADDON_WEBSITE_UNLIMITED = ['sites-unlimited', 'sites-unlimited-2014'];
exports.ADDON_WEBSITE_UNLIMITED = ADDON_WEBSITE_UNLIMITED;
var ADDON_DEDICATED_IP = ['dedicated-ip'];
exports.ADDON_DEDICATED_IP = ADDON_DEDICATED_IP;
var ADDON_ADDITIONAL_PORTAL = ['placeholder'];
exports.ADDON_ADDITIONAL_PORTAL = ADDON_ADDITIONAL_PORTAL;
var ADDON_TRANSACTIONAL_EMAIL = ['transactional-email'];
exports.ADDON_TRANSACTIONAL_EMAIL = ADDON_TRANSACTIONAL_EMAIL;
var ADDITIONAL_CONTACTS = ['additional-contacts-and-emails', 'additional-contacts-and-emails-5x'];
exports.ADDITIONAL_CONTACTS = ADDITIONAL_CONTACTS;


//////////////////
// WEBPACK FOOTER
// ./js/constants/ParcelGroups.js
// module id = 424
// module chunks = 5 6 7